import { Link } from 'react-router-dom';
import FuzzyText from '../../components/FuzzyText';
import "./NotFound.scss";

function NotFound() {
    return (
        <div className='not-found'>
            <h1>
                <FuzzyText
                    baseIntensity={0.2}
                    hoverIntensity={0.5}
                    clickEffect={true}
                    enableHover={true}
                    fontSize="8rem"
                >
                    404
                </FuzzyText>
            </h1>
            <p>Page Not Found</p>
            <Link to="/">Go back home →</Link>
        </div>
    );
}

export default NotFound;
